export { StoryblokIcon } from './lib/icon/icon'
